module.exports = __webpack_public_path__ + "img/good-meter.32e1d8e5.svg";